import React from "react";
import _props from "../../componets/_params";
import Logo from "../../assets/img/hvezda.png";
import { FaDatabase, FaUser } from "react-icons/fa";

import {
    Row,
    Col,
    Form,
    Card,
    Button,
    Placeholder,
    Spinner,
    Image,
    Alert,
} from "react-bootstrap";

class UserRepair extends React.Component {
    state = {
        defaultParams: "Aktuální měsíc",
        docno: "",
        imeiorsn: "",
        externalNo: "",
        transport: "",
        data: [],
        loading: false,
        alert: [],
    };

    correctSet() {
        this.setState({ alert: [], data: [] });
        let cnt = 0;
        if (this.state.docno.length > 0) cnt++;
        if (this.state.imeiorsn.length > 0) cnt++;
        if (this.state.externalNo.length > 0) cnt++;
        if (this.state.docno.transport > 0) cnt++;
        if (this.props.params.id != undefined) cnt = 2;
        if (cnt >= 2) return true;
        if (cnt < 2) return false;
    }

    renderParams() {
        let cnt = 0;
        let text = this.state.defaultParams;
        if (this.state.docno.length > 0) {
            cnt > 0 ? (text += "," + this.state.docno) : (text = this.state.docno);
            cnt++;
        }
        if (this.state.imeiorsn.length > 0) {
            cnt > 0
                ? (text += "," + this.state.imeiorsn)
                : (text = this.state.imeiorsn);
            cnt++;
        }
        if (this.state.externalNo.length > 0) {
            cnt > 0
                ? (text += "," + this.state.externalNo)
                : (text = this.state.externalNo);
            cnt++;
        }
        if (this.state.docno.transport > 0) {
            cnt > 0
                ? (text += "," + this.state.transport)
                : (text = this.state.transport);
            cnt++;
        }
        if (this.props.params.id != undefined) {
            cnt > 0
                ? (text += "," + this.props.params.id)
                : (text = this.props.params.id);
            cnt++;
        }
        return <strong>{text}</strong>;
    }

    renderVendorLogo(firmcode) {
        switch (firmcode) {
            case 2:
                return <Image width={200} src={""} />;
            case 8:
                return <Image width={100} src={""} />;
        }
    }

    getByParams = async () => {
        this.setState({ loading: true });
        const _res = await this.props._api({
            ...this.props,
            method: "post",
            data: {
                DeviceSN: this.state.imeiorsn,
                DocNo: this.props.params.id ? this.props.params.id : this.state.docno,
                NumAtCard: this.state.externalNo,
                TranspCode: this.state.transport,
                userId: this.props.user.userId
            },
            endpoint: "/api/ServiceDocNo/v2/case/user",
            param: "",
        });

        if (_res.status == 200) {
            let alert = this.state.alert;
            alert.push({
                type: "warning",
                text: "Počet nalezených opravenek: " + _res.data.length,
            });
            this.setState({ loading: false, data: _res.data });
        } else {
            let alert = this.state.alert;
            alert.push({
                type: "danger",
                text: "Něco se nepovedlo. Zkuste to prosím později.",
            });
            this.setState({ loading: false, data: [] });
        }
    }

    getDocumentByParams = async () => {
        if (this.correctSet()) {
            this.setState({ loading: true });
            const _res = await this.props._api({
                ...this.props,
                method: "post",
                data: {
                    DeviceSN: this.state.imeiorsn,
                    DocNo: this.props.params.id ? this.props.params.id : this.state.docno,
                    NumAtCard: this.state.externalNo,
                    TranspCode: this.state.transport,
                },
                endpoint: "/api/ServiceDocNo/v2/case/basic",
                param: "",
            });

            if (_res.status == 200) {
                let alert = this.state.alert;
                alert.push({
                    type: "warning",
                    text: "Počet nalezených opravenek: " + _res.data.length,
                });
                this.setState({ loading: false, data: _res.data });
            } else if (_res.status == 404) {
                let alert = this.state.alert;
                alert.push({
                    type: "warning",
                    text: "Dle zadaných parametrů jsme nic nedohledali.",
                });
                this.setState({ alert: alert, loading: false, data: [] });
            } else {
                let alert = this.state.alert;
                alert.push({
                    type: "danger",
                    text: "Něco se nepovedlo. Zkuste to prosím později.",
                });
                this.setState({ alert: alert, loading: false, data: [] });
            }
        } else {
            let alert = this.state.alert;
            alert.push({
                type: "danger",
                text: "Pro vyhledání je nutné zadat minimálně 2 parametry.",
            });
            this.setState({ alert: alert });
        }
    };

    componentDidMount() {
        this.props.setHeaderPage({
            Icon: <FaDatabase className="c-placeholder c-green" />,
            Title: "Moje opravy",
            SubTitle: "Historii zobrazujeme pouze 2 roky od dokončení opravy. Pokud se Vám zakázka nezobrazuje je možné, že je starší než 2 roky.",
        });
        this.getByParams();
    }

    render() {
        return (
            <>
                <Card className="bg-uni mb-4">
                    <Card.Body>
                        {!this.state.loading && this.state.data.length == 0 && (
                            <Row className="mb-4">
                                <Col>
                                    <Row>
                                        <Col xs={12}>
                                            <strong>Parametry hledání</strong>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )}
                        {!this.state.loading && this.state.data.length == 0 && (
                            <Row className="mb-4">
                                <Col xs={12} lg={3}>
                                    <Form.Control
                                        type="text"
                                        value={this.state.imeiorsn}
                                        onChange={(e) =>
                                            this.setState({ imeiorsn: e.target.value })
                                        }
                                    />
                                    <Form.Text>IMEI</Form.Text>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Control
                                        type="text"
                                        value={this.state.docno}
                                        onChange={(e) => this.setState({ docno: e.target.value })}
                                    />
                                    <Form.Text>Číslo zakázky</Form.Text>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Control
                                        type="text"
                                        value={this.state.externalNo}
                                        onChange={(e) =>
                                            this.setState({ externalNo: e.target.value })
                                        }
                                    />
                                    <Form.Text>Externí číslo zakázky</Form.Text>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Control
                                        type="text"
                                        value={this.state.transport}
                                        onChange={(e) =>
                                            this.setState({ transport: e.target.value })
                                        }
                                    />
                                    <Form.Text>Doprava</Form.Text>
                                </Col>
                            </Row>
                        )}

                        <Row>
                            <Col xs={10}>
                                {!this.state.loading && this.state.data.length > 0 && (
                                    <small>Použité parametry: {this.renderParams()}</small>
                                )}
                            </Col>
                            <Col
                                xs={2}
                                className="d-flex justify-content-end align-items-center"
                            >
                                <Button
                                    size="sm"
                                    disabled={this.state.loading}
                                    variant="success"
                                    onClick={() => {
                                        if (this.state.loading || this.state.data.length > 0) {
                                            this.setState({ data: [], loading: false, alert: [] });
                                            this.props.setNavigate("/repair/database");
                                        } else {
                                            this.getDocumentByParams();
                                        }
                                    }}
                                >
                                    {this.state.loading && (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    )}
                                    {!this.state.loading && this.state.data.length == 0 && (
                                        <>Vyhledat</>
                                    )}
                                    {!this.state.loading && this.state.data.length > 0 && (
                                        <>Nové hledání</>
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                {this.state.alert.map((i, idx) => (
                    <Row className="mb-2">
                        <Col xs={12}>
                            <Alert variant={i.type}>{i.text}</Alert>
                        </Col>
                    </Row>
                ))}
                {this.state.loading && (
                    <Card>
                        <Card.Body>
                            <>
                                <Placeholder animation="glow">
                                    <Placeholder xs={8} />
                                </Placeholder>
                                <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                                <Placeholder animation="glow">
                                    <Placeholder xs={10} />
                                </Placeholder>
                            </>
                        </Card.Body>
                    </Card>
                )}
                {!this.state.loading && this.state.data?.length > 0 && (
                    <>
                        {this.state.data.map((i, idx) => (
                            <Card className="mb-2">
                                <div className="card-hdr">
                                    <Row className="mb-2">
                                        <Col>
                                            <Image src={Logo} className="c-logo c-squircle me-2" />
                                            <span>
                                                <strong>Opravenka č.: {i.DocNo}</strong>
                                            </span>
                                        </Col>
                                        <Col className="d-flex justify-content-end">
                                            <div className="c-shadow-wrapper me-4">
                                                <div className="c-squircle c-background-white">
                                                    <FaUser className="c-placeholder c-green" />
                                                </div>
                                            </div>
                                            <span>
                                                <strong>Vaše č. reklamace: {i.NumAtCard}</strong>
                                            </span>
                                        </Col>
                                    </Row>
                                </div>
                                <Card.Body>
                                    <Row className="mb-2 ms-2">
                                        <Col xs={12}>
                                            <strong>Uvedená závada</strong>
                                        </Col>
                                        <Col xs={12}>
                                            <span>{i.DeviceDefectDescEx}</span>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2 ms-2">
                                        <Col xs={8}>
                                            <Row className="mb-2 mt-4">
                                                <Col xs={4} className="d-flex justify-content-start">
                                                    <strong>Výrobce</strong>
                                                </Col>
                                                <Col xs={6}>
                                                    <span>{i.FirmName}</span>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2">
                                                <Col xs={4} className="d-flex justify-content-start">
                                                    <strong>Typ přístroje</strong>
                                                </Col>
                                                <Col xs={6}>
                                                    <span>{i.TypeName}</span>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2">
                                                <Col xs={4} className="d-flex justify-content-start">
                                                    <strong>Sérivé číslo</strong>
                                                </Col>
                                                <Col xs={6}>
                                                    <span>{i.ProductCodeSN}</span>
                                                </Col>
                                            </Row>
                                            <Row className="mb-2 mt-4">
                                                <Col xs={4} className="d-flex justify-content-start">
                                                    <strong>Status</strong>
                                                </Col>
                                                <Col xs={6}>
                                                    <span>{i.WebName}</span>
                                                </Col>
                                            </Row>
                                            {i.DateFinish != "1900-01-01T00:00:00" && (
                                                <Row className="mb-2">
                                                    <Col xs={4} className="d-flex justify-content-start">
                                                        <strong>Odesláno dne</strong>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <span>
                                                            {new Date(i.DateFinish).toLocaleDateString()}
                                                        </span>
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                        <Col xs={4}>{this.renderVendorLogo(i.DeviceFirmCode)}</Col>
                                    </Row>
                                </Card.Body>
                                {this.props.user.type == "annonymous" && (
                                    <div className="anonymous-layer">
                                        Více uvidíš po přihlášení
                                    </div>
                                )}
                            </Card>
                        ))}
                    </>
                )}
            </>
        );
    }
}

export default _props(UserRepair);
